<div class="p-5">
    <h2 class="primary text-center fw-bold">Invita il discente</h2>
    <p class="text-center">
        Indica la mail a cui inviare il codice di attivazione e il codice fiscale del discente:
    </p>
    <!-- Form -->
    <form [formGroup]="formInviteLearner" class="row g-3 mt-2">
        <app-form-input [inputItem]="inviteLearnerFormFields().fiscalCode"></app-form-input>
        <app-form-input [inputItem]="inviteLearnerFormFields().email"></app-form-input>
        <mat-dialog-actions class="d-flex gap-3">
            <button mat-dialog-close class="btn btn-primary-ks-white"
            (click)="onCancel()">Annulla</button> 
            <button #initialFocus class="btn btn-primary-ks"
            [disabled]="formInviteLearner.invalid || isSubmitting" (click)="onSubmit()">Invia</button>
        </mat-dialog-actions>
    </form>
</div>